<script lang="ts">
	export let onClick = () => {};
	export let loading = false;
	export let cssClass = '';
</script>

<button type="button" class="button {cssClass}" class:loading={loading} {...$$props} on:click={onClick}>
	{#if loading}
		<span>&nbsp;</span>
		<span class="spinner"></span>
	{:else}
		<span><slot /></span>
	{/if}
</button>

<style>
	button {
		position: relative;
		&.load > span { color: rgba(255, 255, 255, 0); }
	}
	.spinner {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
</style>